// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
    android_version: '1', // debe ser la misma que en android studio y la misma que en el parametro global
    android_url: 'https://play.google.com/store/apps/details?id=com.core.appsafetyaco',
    //  api: 'http://localhost:8000/api/',
     api: 'https://acoappsafety.com/api/',
  firebaseConfig : {
    apiKey: "AIzaSyAAVTpConkoYAkOq6G2pNVM-2DB-vlb2eM",
    authDomain: "appacosafety.firebaseapp.com",
    databaseURL: "https://appacosafety.firebaseio.com",
    projectId: "appacosafety",
    storageBucket: "appacosafety.appspot.com",
    messagingSenderId: "133801868612",
    appId: "1:133801868612:web:6c38d83c1f29cad989eb11",
    measurementId: "G-TGLEWE1SMQ"
  },
    appId: 'com.core.appsafetyaco',
    appIdios: 'id6504500277',
    // TEST
    // stripe_public_key: 'pk_test_51L9BdFIFiJBwZ6xwcLSXRVLOIbRjfEiwguuQYly9j5bj5tMov1rJNRfIck32c8kaqhD3qvbiWBvgTitXbF6RqO4I0054bnZVFY'
    // LIVE
    stripe_public_key: 'pk_live_51L9BdFIFiJBwZ6xwR3ugrwUfV24BSoHlHs0p4TvyZxYrjV6qKslnmbofKcbcXjgHcUTWtTAcAunjvBUSCSWyySdB00UjL4WQoc'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
